import { render, staticRenderFns } from "./CDEKTable.vue?vue&type=template&id=aecf08ea&scoped=true"
import script from "./CDEKTable.vue?vue&type=script&lang=js"
export * from "./CDEKTable.vue?vue&type=script&lang=js"
import style0 from "./CDEKTable.vue?vue&type=style&index=0&id=aecf08ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aecf08ea",
  null
  
)

export default component.exports